import * as React from 'react'

import DividerComp from '../../components/DividerComp/DividerComp'
import Heading from '../../components/Heading/Heading'
import Image from '../../components/Image/Image'
import Link from '../../components/Link/Link'
import Paragraph from '../../components/Paragraph/Paragraph'
import VideoPlayer from '../../components/VideoPlayer/VideoPlayer'
import type { ImageViewModel } from '../../view-models/ImageViewModel'
import type { LinkViewModel } from '../../view-models/LinkViewModel'
import type { VideoViewModel } from '../../view-models/VideoViewModel'
import type { ImageSizes } from '../../utils/image-utils'
import styles from './header-style.css'
import { HyphenatedText } from '@/components/HyphenatedTextProps/HyphenatedTextProps'
import cx from 'classnames'

type Props = {
  toptitle?: string
  title?: string
  subtitle?: string
  image?: ImageViewModel
  video?: VideoViewModel
  banner?: {
    image?: ImageViewModel
    link?: LinkViewModel
  }
  noBottomMargin?: boolean
  divider?: boolean
}
type State = {}
const imgSizes: ImageSizes = {
  maxWidth: '1350px',
}

class Header extends React.Component<Props, State> {
  static displayName = 'Header'
  static defaultProps = {}

  render() {
    const { toptitle, title, subtitle, image, video, banner , noBottomMargin = false, divider = true} = this.props

    return (
      <header className={cx(styles.header, noBottomMargin && styles.noBottomMargin)}>
        {toptitle && (
          <Paragraph marginBottom="none" className={styles.toptitle}>
            {toptitle}
          </Paragraph>
        )}
        {title && <Heading  className={styles.title}><HyphenatedText minWordLength={10} text={title} /></Heading>}
        {subtitle && (
          <Paragraph marginBottom="small" className={styles.subtitle}>
            {subtitle}
          </Paragraph>
        )}
        {video && (
          <div className={styles.video}>
            <VideoPlayer {...video} />
          </div>
        )}
        {image && (
          <div className={styles.image}>
            <Image sizes={imgSizes} {...image} defaultAspect={50 / 135} autoAspectRatio />
          </div>
        )}
        {banner && banner.image && (
          <Link
            className={styles.bannerLink}
            {...banner.link}
          >
            <Image {...banner.image} contain />
          </Link>
        )}
        {divider && <DividerComp showOnDesktop />}
      </header>
    )
  }
}

export default Header